// @flow
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Modal,
  Select,
  Switch,
  Collapse,
  Row,
  Col,
  Radio,
} from 'antd';
import {
  MESSAGES,
} from 'appconstants';
import { NOTIFICATION } from 'store/actionTypes';
import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import {
  notificationActions,
  shopDetailsActions,
} from 'store/actions';
import {
  SpH5,
  SpButton,
  SpError,
} from 'components/DesignKit';
import {
  SpText,
} from 'components/PaymentWidgetDesignKit';
import availImage from 'assets/imgs/avail.png';

const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;

type Props = {
  close: Function,
  submit: Function,
  visible: boolean,
  submitting: boolean,
  itemsList: Array,
  modifierItemsList: Array,
  setNotification: Function,
  labelList: Array,
  selectedRowKeys: Array,
  shopsList: Array,
  fetchAllShopDetails: Function,
  SelectedKeys: Array,
};

const BulkEdit = (props: Props) => {
  const {
    visible,
    close,
    submit,
    submitting,
    itemsList,
    modifierItemsList,
    setNotification,
    labelList,
    selectedRowKeys,
    shopsList,
    fetchAllShopDetails,
    SelectedKeys,
  } = props;

  const [disableButton, setDisableButton] = useState(false);
  const [onKiosk, setOnKiosk] = useState(false);
  const [hidden, sethidden] = useState(false);
  const [available, setAvailable] = useState(false);
  const [onlineEnabled, setOnlineEnabled] = useState(false);
  const [categories, setCategories] = useState([]);
  const [modifierGroups, setModifierGroups] = useState([]);
  const [priceType, setPriceType] = useState('');
  const [description, setDescription] = useState('');
  const [shopDetails, setShopDetails] = useState([]);
  const [tagDetails, setTagDetails] = useState([]);
  const [sku, setSKU] = useState('');
  const [enableStock, setEnableStock] = useState(false);
  const [enableDynamicAvailability, setEnableDynamicAvailability] = useState(false);
  const [stockQuantity, setStockQuantity] = useState(0);
  const [onlineAvailability, setOnlineAvailability] = useState(50);
  const [posAvailability, setPosAvailability] = useState(50);
  const [unitName, setunitName] = useState('');
  const [errorMsg, setErrorMsg] = useState('Unit Name required');

  useEffect(() => {
    fetchAllShopDetails('&sortBy=createdAt&direction=DESC');
    if (SelectedKeys && SelectedKeys?.length > 0) {
      const uniqueCategories = SelectedKeys.reduce((acc, item) => {
        (item.categories || []).forEach(category => {
          if (!acc.some(c => c.gid === category.gid)) {
            acc.push(category);
          }
        });
        return acc;
      }, []);
      const catGIds = (uniqueCategories && uniqueCategories.length !== 0)
        ? uniqueCategories.map((option) => option.gid) : [];
      setCategories(catGIds);
      const uniqueModifierGroups = SelectedKeys.reduce((acc, item) => {
        (item.modifierGroups || []).forEach(modifierGroup => {
          if (!acc.some(c => c.gid === modifierGroup.gid)) {
            acc.push(modifierGroup);
          }
        });
        return acc;
      }, []);
      const modifierGroupsGIds = (uniqueModifierGroups && uniqueModifierGroups.length !== 0)
        ? uniqueModifierGroups.map((option) => option.gid) : [];
      setModifierGroups(modifierGroupsGIds);
      const uniqueShops = SelectedKeys.reduce((acc, item) => {
        (item.shops || []).forEach(shop => {
          if (!acc.some(c => c.gid === shop.gid)) {
            acc.push(shop);
          }
        });
        return acc;
      }, []);
      const shopGIds = (uniqueShops && uniqueShops.length !== 0)
        ? uniqueShops.map((option) => option.gid) : [];
      setShopDetails(shopGIds);
      const uniqueTags = SelectedKeys.reduce((acc, item) => {
        (item.tags || []).forEach(tag => {
          if (!acc.some(c => c.gid === tag.gid)) {
            acc.push(tag);
          }
        });
        return acc;
      }, []);
      const tagGIds = (uniqueTags && uniqueTags.length !== 0)
        ? uniqueTags.map((option) => option.gid) : [];
      setTagDetails(tagGIds);
    }
  }, []);

  useEffect(() => {
    if (!submitting) {
      setDisableButton(false);
    }
  }, [submitting]);

  const availabilityView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'AVAILABILITY_VIEW',
      itemGids: selectedRowKeys,
      hidden: !hidden,
      onKiosk,
      available,
      onlineEnabled,
    };
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items availability updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  const handleSelectChange = (values) => {
    setCategories(values);
  };

  const categorysView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'CATEGORIES_VIEW',
      itemGids: selectedRowKeys,
      categoryGids: categories,
    };
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items categorys updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  const handleSelectModifierChange = (values) => {
    setModifierGroups(values);
  };

  const modifiersView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'MODIFIER_GROUPS_VIEW',
      itemGids: selectedRowKeys,
      modifierGroupGids: modifierGroups,
    };
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items modifiers updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  const priceTypeViewUpdate = (data) => {
    setPriceType(data.target.value);
    setErrorMsg('');
  };

  // eslint-disable-next-line consistent-return
  const priceTypeView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'PRICE_TYPE_VIEW',
      itemGids: selectedRowKeys,
      priceType,
    };
    if (priceType === 'PER_UNIT' && unitName) {
      payload.unitName = unitName;
      setErrorMsg('');
    } else if (priceType === 'PER_UNIT' && !unitName) {
      setErrorMsg('Unit Name is required');
      setDisableButton(false);
      return false;
    }
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items price type updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  const descriptionView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'DESCRIPTION_VIEW',
      itemGids: selectedRowKeys,
      description,
    };
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items description updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  const handleSelectShopChange = (values) => {
    setShopDetails(values);
  };

  const shopsView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'SHOPS_VIEW',
      itemGids: selectedRowKeys,
      shopGids: shopDetails,
    };
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items shops updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  const handleSelectTagChange = (values) => {
    setTagDetails(values);
  };

  const printersView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'PRINTER_LABELS_VIEW',
      itemGids: selectedRowKeys,
      tagGids: tagDetails,
    };
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items printer labels updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  const skuView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'SKUS_VIEW',
      itemGids: selectedRowKeys,
      sku,
    };
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items SKU updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  const handlePosAvailabilityChange = (value) => {
    const newValue = Number(value);
    if (value === '') {
      setPosAvailability(0);
      setOnlineAvailability(100);
    } else if (newValue) {
      const remaining = 100 - newValue;
      setPosAvailability(newValue);
      setOnlineAvailability(remaining >= 0 ? remaining : 0);
    }
  };

  const handleOnlineAvailabilityChange = (value) => {
    const newValue = Number(value);
    if (value === '') {
      setOnlineAvailability(0);
      setPosAvailability(100);
    } else if (newValue) {
      const remaining = 100 - newValue;
      setOnlineAvailability(newValue);
      setPosAvailability(remaining >= 0 ? remaining : 0);
    }
  };

  const stockView = async () => {
    setDisableButton(true);
    const payload = {
      type: 'STOCKS_VIEW',
      itemGids: selectedRowKeys,
      enableStock,
      stockQuantity: Number(stockQuantity),
      enableDynamicAvailability,
      onlineAvailability: Number(onlineAvailability * 100),
      posAvailability: Number(posAvailability * 100),
    };
    try {
      const { data: { entity } } = await axiosAuthInstance.patch(API_END_POINTS.ITEM_BULK_EDIT, payload);
      console.log(entity);
      close();
      submit();
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'Items stocks updated successfully',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setDisableButton(false);
    }
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Close</SpButton>,
      ]}
      title="Bulk Edit Items"
    >
      <div className="px-4">
        <div className={submitting ? 'OVERLAY' : ''} />
        <div className="mb-3">
          Select an attribute below to edit for selected items
        </div>
        <div>
          <Collapse expandIconPosition="start" accordion style={{ border: 'none', paddingTop: '3px' }}>
            <Panel
              header={(
                <SpText fontSize="16px">
                  Availability
                </SpText>
              )}
            >
              <img src={availImage} alt="avail" width="450" />
              <div className="mt-3">
                <SpH5>Item Availability</SpH5>
                <div>Choose where items are displayed for sales.</div>
                <div className="mt-2">
                  <Switch
                    defaultChecked={onKiosk}
                    onChange={() => setOnKiosk(true)}
                  /> <SpText> Show on Kiosk</SpText>
                </div>
                <div className="mt-2">
                  <Switch
                    defaultChecked={hidden}
                    onChange={() => sethidden(true)}
                  /> <SpText> Show on POS</SpText>
                </div>
                <div className="mt-2">
                  <Switch
                    defaultChecked={onlineEnabled}
                    onChange={() => setOnlineEnabled(true)}
                  /> <SpText> Show on Online</SpText>
                </div>
                <div className="mt-2">
                  <Switch
                    defaultChecked={available}
                    onChange={() => setAvailable(true)}
                  /> <SpText> Show on Available</SpText>
                </div>
                <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                  <Col>
                    <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                    <SpButton onClick={() => availabilityView()} disabled={disableButton}>Update</SpButton>
                  </Col>
                </Row>
              </div>
            </Panel>
            <Panel
              header={(
                <SpText fontSize="16px">
                  Categories
                </SpText>
              )}
            >
              <div className="mt-3">
                <Select
                  className="w-100"
                  mode="multiple"
                  allowClear
                  placeholder="Select categories"
                  onChange={handleSelectChange}
                  value={categories}
                  showSearch
                  optionFilterProp="name"
                  style={{ width: '100%' }}
                >
                  {itemsList.map((item) => (
                    <Option key={item.gid} name={item.name} value={item.gid}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
                <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                  <Col>
                    <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                    <SpButton onClick={() => categorysView()} disabled={disableButton}>Update</SpButton>
                  </Col>
                </Row>
              </div>
            </Panel>
            <Panel
              header={(
                <SpText fontSize="16px">
                  Modifier Groups
                </SpText>
              )}
            >
              <div className="mt-3">
                <Select
                  className="w-100"
                  mode="multiple"
                  allowClear
                  placeholder="Select modifier groups"
                  onChange={handleSelectModifierChange}
                  value={modifierGroups}
                  showSearch
                  optionFilterProp="name"
                  style={{ width: '100%' }}
                >
                  {modifierItemsList.map((item) => (
                    <Option key={item.gid} name={item.name} value={item.gid}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
                <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                  <Col>
                    <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                    <SpButton onClick={() => modifiersView()} disabled={disableButton}>Update</SpButton>
                  </Col>
                </Row>
              </div>
            </Panel>
            <Panel
              header={(
                <SpText fontSize="16px">
                  Pricing Type
                </SpText>
              )}
            >
              <div className="mt-3">
                <Radio.Group onChange={priceTypeViewUpdate} value={priceType}>
                  <Radio value="FIXED">Fixed</Radio>
                  <Radio value="VARIABLE">Variable</Radio>
                  <Radio value="PER_UNIT">Per Unit</Radio>
                </Radio.Group>
                {
                  priceType === 'PER_UNIT' && (
                    <div className="mt-3">
                      <label>Unit Name</label>
                      <Input
                        type="text"
                        onChange={(e) => { setunitName(e.currentTarget.value); setErrorMsg(''); }}
                        value={unitName}
                        placeholder="Unit Name"
                      />
                      <SpError>{errorMsg || ''}</SpError>
                    </div>
                  )
                }
                <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                  <Col>
                    <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                    <SpButton onClick={() => priceTypeView()} disabled={disableButton}>Update</SpButton>
                  </Col>
                </Row>
              </div>
            </Panel>
            {
              selectedRowKeys?.length === 1 ? (
                <Panel
                  header={(
                    <SpText fontSize="16px">
                      Description
                    </SpText>
                  )}
                >
                  <div className="mt-3">
                    <TextArea
                      maxLength={255}
                      rows={5}
                      placeholder="Description"
                      value={description}
                      onChange={(e) => setDescription(e.currentTarget.value)}
                    />
                    <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                      <Col>
                        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                        <SpButton onClick={() => descriptionView()} disabled={disableButton}>Update</SpButton>
                      </Col>
                    </Row>
                  </div>
                </Panel>
              ) : (
                <></>
              )
            }
            {
              selectedRowKeys?.length === 1 ? (
                <Panel
                  header={(
                    <SpText fontSize="16px">
                      SKU
                    </SpText>
                  )}
                >
                  <div className="mt-3">
                    <Input type="text" value={sku} onChange={(e) => setSKU(e.currentTarget.value)} placeholder="SKU" />
                    <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                      <Col>
                        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                        <SpButton onClick={() => skuView()} disabled={disableButton}>Update</SpButton>
                      </Col>
                    </Row>
                  </div>
                </Panel>
              ) : (
                <></>
              )
            }
            <Panel
              header={(
                <SpText fontSize="16px">
                  Stocks
                </SpText>
              )}
            >
              <div className="mt-3">
                <div className="mb-3">
                  <Switch
                    className="mr-2"
                    checked={enableStock}
                    onChange={setEnableStock}
                  /> Enable Stocks
                </div>
                <div className="mb-3">
                  <label htmlFor=""><SpH5>Quantity</SpH5></label>
                  <Input
                    placeholder="Quantity"
                    disabled={!enableStock}
                    type="number"
                    min={0}
                    onChange={(e) => setStockQuantity(e.currentTarget.value)}
                    value={stockQuantity}
                  />
                </div>
                <div className="mb-3">
                  <Switch
                    className="mr-2"
                    disabled={!enableStock}
                    defaultChecked={enableDynamicAvailability}
                    onChange={setEnableDynamicAvailability}
                  /> Enable Dynamic Stocks
                </div>
                <div className="mb-3">
                  <label htmlFor=""><SpH5>On Pos</SpH5></label>
                  <Input
                    placeholder="On Pos"
                    suffix="%"
                    type="number"
                    min={0}
                    max={100}
                    disabled={!enableDynamicAvailability}
                    onChange={(e) => handlePosAvailabilityChange(e.currentTarget.value)}
                    value={posAvailability}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor=""><SpH5>On Online</SpH5></label>
                  <Input
                    placeholder="On Online"
                    suffix="%"
                    type="number"
                    min={0}
                    max={100}
                    disabled={!enableDynamicAvailability}
                    onChange={(e) => handleOnlineAvailabilityChange(e.currentTarget.value)}
                    value={onlineAvailability}
                  />
                </div>
                <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                  <Col>
                    <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                    <SpButton onClick={() => stockView()} disabled={disableButton}>Update</SpButton>
                  </Col>
                </Row>
              </div>
            </Panel>
            <Panel
              header={(
                <SpText fontSize="16px">
                  Shops
                </SpText>
              )}
            >
              <div className="mt-3">
                <Select
                  className="w-100"
                  mode="multiple"
                  allowClear
                  placeholder="Select shops"
                  onChange={handleSelectShopChange}
                  value={shopDetails}
                  showSearch
                  optionFilterProp="name"
                  style={{ width: '100%' }}
                >
                  {shopsList && shopsList.map((item) => (
                    <Option key={item.gid} name={item.name} value={item.gid}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
                <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                  <Col>
                    <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                    <SpButton onClick={() => shopsView()} disabled={disableButton}>Update</SpButton>
                  </Col>
                </Row>
              </div>
            </Panel>
            <Panel
              header={(
                <SpText fontSize="16px">
                  Printer Labels
                </SpText>
              )}
            >
              <div className="mt-3">
                <Select
                  className="w-100"
                  mode="multiple"
                  allowClear
                  placeholder="Select tags"
                  onChange={handleSelectTagChange}
                  value={tagDetails}
                  showSearch
                  optionFilterProp="name"
                  style={{ width: '100%' }}
                >
                  {labelList.map((item) => (
                    <Option key={item.gid} name={item.name} value={item.gid}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
                <Row type="flex" justify="end" className="my-2 mb-3 mt-2">
                  <Col>
                    <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
                    <SpButton onClick={() => printersView()} disabled={disableButton}>Update</SpButton>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Collapse>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  test: state.account.test,
  shopsList: state.shopDetails.shopsList.content,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllShopDetails: (payload) => dispatch(shopDetailsActions.fetchAllShopDetails({
    payload,
  })),
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(BulkEdit);
